import { DrawerSize, Position } from "@blueprintjs/core"
import React from "react"
import CustomDrawer, { CustomDrawerProps } from "../../Atoms/CustomDrawer"
// import CustomDrawer, { CustomDrawerProps } from "../Atoms/CustomDrawer";

interface AnalyticsDrawerProps extends CustomDrawerProps {
  /**
   * Descriptory property of the analytics
   */
  subtitle?: string
}
const AnalyticsDrawer = ({
  title,
  subtitle,
  children,
  ...props
}: AnalyticsDrawerProps) => {
  return (
    <CustomDrawer
      drawerClassName="vt-inward-summary-drawer-popover"
      position={Position.TOP}
      icon="pie-chart"
      title={
        <span>
          <span className="text-muted">{title} </span>
          <span className="vt-highlight">{subtitle}</span>{" "}
        </span>
      }
      size={DrawerSize.SMALL}
      className="p-3 vt-inward-summary-drawer"
      {...props}
    >
      {children}
    </CustomDrawer>
  )
}

export const AggregationNotAvailable = () => {
  return (
    <div className="h-full w-full flex justify-center items-center">
      <p className="lead">Aggregated Data is not available, please try again</p>
    </div>
  )
}

export default AnalyticsDrawer
